var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 27 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-Movil",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Proposals-empty",
    transform: "translate(-98.000000, -743.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab-Bar",
    transform: "translate(0.000000, 728.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.169842,23.5897957 L122.169842,18.0782947 C122.169842,17.7911723 122.005056,17.5352589 121.734807,17.4041813 C121.47115,17.2731037 121.14817,17.2918291 120.897695,17.4541156 C115.110416,21.2428825 111.788333,21.7297422 109.540654,21.7297422 L103.114006,21.7297422 C100.569713,21.7297422 98.5000027,23.6896644 98.5000027,26.0989955 L98.5000027,27.7218611 C98.5000027,30.1311922 100.569713,32.0911144 103.114006,32.0911144 L105.779964,32.148618 L107.946463,37.9374788 C108.092109,38.353054 108.66523,38.4842983 108.981619,38.4842983 C108.999844,38.4842983 109.13854,38.461644 109.160807,38.4537371 C109.576067,38.2914505 109.986271,37.7260709 109.821485,37.3328381 L107.945527,32.0911144 L109.534063,32.0911144 C117.364687,32.0911144 120.568123,36.0172007 120.713135,36.1982126 C120.871329,36.3979499 121.108621,36.5103021 121.359095,36.5103021 C121.444784,36.5103021 121.530473,36.4978185 121.60957,36.4728514 C121.939142,36.3667409 122.16325,36.0796186 122.16325,35.7488037 L122.16325,30.2435444 C123.764969,29.8940042 124.958018,28.5395356 124.958018,26.9166701 C124.971201,25.2938045 123.77156,23.9330942 122.169842,23.5897957 Z M120.657053,33.8494688 C118.850113,32.4496927 115.302664,30.5000046 109.549685,30.5000046 L107.54345,30.5000046 L107.54345,23.1886742 L109.549685,23.1886742 C111.874792,23.1886742 115.20966,22.7387462 120.657053,19.439274 L120.657053,33.8494688 Z M122.169842,28.875044 L122.169842,25.0090305 C123.06688,25.3387994 123.684651,26.0825334 123.684651,26.9455455 C123.693114,27.8015412 123.06688,28.5452752 122.169842,28.875044 Z",
    id: "Shape",
    transform: "translate(111.729064, 27.900965) rotate(-13.000000) translate(-111.729064, -27.900965) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMegaphone);
export default __webpack_public_path__ + "static/media/icon-megaphone.7faec435.svg";
export { ForwardRef as ReactComponent };